(() => {
  const { body } = document;
  const header = document.querySelector(".header-bar");
  const fusedHeader = document.createElement("div");
  const headerParent = header.parentElement;
  const menuParent = document.querySelector(".menu-items").parentElement;

  body.insertBefore(fusedHeader, headerParent);

  fusedHeader.append(headerParent, menuParent);

  let previousScrollHeight = window.scrollY;

  const upperSiblings = [];
  // eslint-disable-next-line no-restricted-syntax
  for (const child of body.children) {
    if (child.isEqualNode(fusedHeader)) {
      upperSiblings.push(child);
      break;
    }
    upperSiblings.push(child);
  }

  const handleHeaderAnimation = () => {
    const scrollOffset = upperSiblings.reduce(
      (acc, curr) => acc + curr.scrollHeight,
      0
    );
    body.style.setProperty(
      "--header-move-transform",
      `translateY(-${fusedHeader.scrollHeight}px)`
    );
    if (window.scrollY <= scrollOffset - fusedHeader.scrollHeight) {
      fusedHeader.classList.remove("header-bar--sticky");
    }
    if (
      window.scrollY > previousScrollHeight &&
      window.scrollY > scrollOffset
    ) {
      fusedHeader.classList.add("header-bar--move-out");
      setTimeout(() => {
        fusedHeader.classList.add("header-bar--sticky");
      }, 300);
    } else {
      fusedHeader.classList.remove("header-bar--move-out");
    }
    previousScrollHeight = window.scrollY;
  };

  handleHeaderAnimation();

  window.addEventListener("scroll", handleHeaderAnimation);

  window.addEventListener("functionalScroll", (e) => {
    window.removeEventListener("scroll", handleHeaderAnimation);
    setTimeout(() => {
      window.addEventListener("scroll", handleHeaderAnimation);
    }, e.detail);
  });
})();
